import React, { useEffect, useState } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { Button } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { DataGridPro } from '@mui/x-data-grid-pro';
import AuditChecklistHistoryApiService from '../../api/AuditChecklistHistoryApiService';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const auditChecklistHistoryApiService = new AuditChecklistHistoryApiService();
export default function AuditChecklistHistoryModal (props) {
    const {
        currentSelectedAuditChecklist,
        open,
        onCancel,
    } = props;
    const { t } = useTranslation();

    const [auditChecklists, setAuditChecklists] = useState([]);
    const [loading, setLoading] = useState(false);

    const columns = [
        {
            field: 'chCompletedBy',
            headerName: t('common.completedBy'),
            flex: 1,
        },
        {
            field: 'chCompletionDatetime',
            headerName: t('common.completedOn'),
            flex: 2,
        },
        {
            field: 'auditChecklistHistoryItems',
            headerName: t('auditChecklistHistory.column.tasksCreated'),
            flex: 2,
            renderCell: (params) => {
                let tasksCreated = 0;

                for (const checklist of params.value) {
                    if (checklist.taskId) {
                        tasksCreated++;
                    }
                }

                return tasksCreated;
            }
        },
    ]

    const subGridColumns = [
        { field: 'hiPrompt', headerName: t('editAuditChecklist.column.prompt'), flex: 2 },
        {
            field: 'hiAnswer',
            headerName: t('auditChecklistHistory.column.answer'),
            flex: 0.5,
            renderCell: (params) => {
                if (params.value === '0') return t('common.yes');
                if (params.value === '1') return t('common.no');
                return params.row.taskId ? t('common.no') : t('common.yes');
            },
        },
        {
            field: 'taskId',
            headerName: t('fieldName.task'),
            flex: 1,
            renderCell: (params) => {
                if (!params.value) return '';
                return (
                    <Link
                        to={`/Task/${params.value}`}
                        style={{
                            textDecoration: 'underline',
                            color: 'blue',
                            cursor: 'pointer',
                        }}
                    >
                        {params.value}
                    </Link>
                );
            },
        }
    ]

    useEffect(() => {
        if (open) {
            setAuditChecklists([]);
            setLoading(true);
            auditChecklistHistoryApiService.getAuditChecklistHistory(currentSelectedAuditChecklist.acId).then((auditChecklistHistoryResponse) => {
                setAuditChecklists(auditChecklistHistoryResponse.data);
                setLoading(false);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    function handleCancel () {
        onCancel();
    }
    const CustomRowRenderer = ({ row: rowProp }) => (
        <div>
            <DataGridPro
                rows={rowProp.auditChecklistHistoryItems}
                columns={subGridColumns}
                getRowId={(row) => row.id}
                autoHeight
                disableColumnMenu
            />
        </div>
    );


    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '175%', height: '100vh' }}}
            maxWidth='xl'
            fullWidth
            open={open}>
            <DialogTitle>{t('auditChecklistHistory.title', { title: currentSelectedAuditChecklist.acTitle })}</DialogTitle>
            <DialogTitle style={{ fontSize: '16px' }}>{currentSelectedAuditChecklist.projectName}</DialogTitle>
            <DialogContent dividers>
                <DataGridPro
                    rows={auditChecklists}
                    columns={columns}
                    loading={loading}
                    getRowId={(row) => row.chId}
                    getRowHeight={() => 'auto'}
                    getDetailPanelContent={CustomRowRenderer}
                />
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCancel}>
                    {t('common.cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
